export default __webpack_public_path__ + "static/mic2-bb4512ece0356dc98421d86fbfad5f60.jpg";